import { getSiteConfig } from '@veranda/shared/lib/site-config';

export const siteConfig = getSiteConfig('tilecloud');
